import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_PATIENT_LIST = 'GET_PATIENT_LIST';
export const GET_PATIENT_LIST_SUCCESS = 'GET_PATIENT_LIST_SUCCESS';
export const GET_PATIENT_LIST_FAILURE = 'GET_PATIENT_LIST_FAILURE';

// Action Creators
export const getPatientList = () => ({
  type: GET_PATIENT_LIST,
});

export const getPatientListSuccess = (users) => ({
  type: GET_PATIENT_LIST_SUCCESS,
  payload: users,
});

export const getPatientListFailure = (error) => ({
  type: GET_PATIENT_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getPatientListData = (external, pageCount, data, search) => {
  return async (dispatch) => {
    dispatch(getPatientList());
    try {
      const requestUrl =
        pageCount !== undefined
          ? `${url?.getPatient}?page=${pageCount}${data && `&${data}`}${search && `&${search}`}`
          : url?.getPatient;
      const response = await getMethodWithToken(requestUrl);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getPatientListSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getPatientListFailure(error?.message));
    }
  };
};
